import SvgIcon from "./SvgIcon";
import dataEmpty from "./dataEmpty"
const commonComponents = {};
commonComponents.components = [
    SvgIcon,dataEmpty
];

commonComponents.install = function(Vue) {
    this.components.map((r) => Vue.component(r.name, r));
};
export default commonComponents;